import { render } from "./EditBookingDialog.vue?vue&type=template&id=64141242"
import script from "./EditBookingDialog.vue?vue&type=script&lang=js"
export * from "./EditBookingDialog.vue?vue&type=script&lang=js"

import "./EditBookingDialog.vue?vue&type=style&index=0&id=64141242&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__